import styled from 'styled-components'

import { COLOR } from 'styles/constants'

export const Wrapper = styled.div`
  display: block;
  margin-left: auto;
  margin-right: auto;
  .slick-disabled {
    display: none !important;
  }

  .slick-prev:before {
    display: none;
  }

  .slick-next:before {
    display: none;
  }

  .slick-prev {
    z-index: 2;
    left: -16px;
  }

  .slick-next {
    z-index: 2;
    right: -16px;
  }
`

export const StyledButton = styled.button`
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-color: white !important;
  border: 1px solid ${COLOR.GRAY_SCALE_30};
  :hover {
    background-color: ${COLOR.GRAY_SCALE_15} !important;
  }
`
